import { SYSAction, html } from "../../../../../../_ovlclient/src"
import { FeatureInfo } from "../../../../../../_ovlclient/src/global/globalapi"
import {
  HookFieldGetList_ReturnType,
  HookFieldGetList_Type,
  HookFieldGetValueRender_ReturnType,
  HookFieldGetValueRender_Type,
  HookFormAdd_Type,
  HookLookupsRefresh_ReturnType,
  HookLookupsRefresh_Type,
  HookTableRowFn_Type,
  HookTableRowFnConfirm_Type,
} from "../../../../../../_ovlclient/src/global/hooks"
import { DialogOkCancel } from "../../../../../../_ovlclient/src/library/dialog/dialogapi"
import { SnackAdd } from "../../../../../../_ovlclient/src/library/snackapi"
import { TableGet } from "../../../../../../_ovlclient/src/library/table/tableapi"
import { T } from "../../../../../../_ovlclient/src/textapi"

const HookTableRowFnConfirm: SYSAction<HookTableRowFnConfirm_Type> = async (
  value
) => {
  if (value.fnKey === "SYSDelete") {
    //if any of the selected has a Token already (remember: we can start this in theory from multidelete)
    value.validKeys.forEach((k) => {
      if (value.rows[k]["HasToken"]) {
        value.toSet.invalidKeys.push(k)
      }
    })
    if (value.toSet.invalidKeys.length > 0) {
      let res =
        (await DialogOkCancel(T("SPCSymbolPCDeleteConfirmIfRegistered"), {
          type: "warning",
        })) === 1
      if (res) {
        value.toSet.invalidKeys = []
        value.toSet.noPrompt = true
      } else {
        value.toSet.cancelFn = true
      }
    }
  }
}

const HookFormAdd: SYSAction<HookFormAdd_Type> = async (value) => {
  let tb = TableGet("SPCSymbolPC")
  let id
  do {
    id = getRandomId()
  } while (tb.getKeys({ byFilter: { U_Id: id } }).length > 0)
  value.newRow["U_Id"] = id
}
const HookLookupsRefresh: SYSAction<
  HookLookupsRefresh_Type,
  HookLookupsRefresh_ReturnType
> = (_, { global }) => {
  let state = global.getState()
  return {
    OCRD: state.app.global.GEN.lookups.OCRD,
  }
}

const HookField_U_CardCode_GetList: SYSAction<
  HookFieldGetList_Type,
  HookFieldGetList_ReturnType
> = (value, { global }) => {
  let state = global.getState()
  let lookupState = state.app.global.GEN.lookups.OCRD
  let data = lookupState.data
  if (value.formState) {
    let selectedVal = value.formState.row["U_CardCode"]
    data = Object.keys(data).reduce((val, k) => {
      if (
        data[k].CardType === "C" &&
        data[k].IsSPCCustomer &&
        (data[k].Active || data[k].CardCode === selectedVal)
      ) {
        val[k] = data[k]
      }
      return val
    }, {})
  }
  return { data, lookupDef: lookupState.lookupDef }
}

const HookField_U_Id_GetValueRender: SYSAction<
  HookFieldGetValueRender_Type,
  HookFieldGetValueRender_ReturnType
> = (value) => {
  // prettier-ignore
  let res = html`<button
      @click=${async (e) => {
        e.stopPropagation()
        await navigator.clipboard.writeText(value.row["U_Id"])
        SnackAdd(T("SYSCopyToClipboardSnack"))
      }}
      class="fd-button __clipboardbtn"
      title=${T("SYSCopyToClipboard")}
    ><i class="sap-icon--action"></i></button>&nbsp;${value.row["U_Id"]}`

  return { res, valueRaw: value.row["U_Id"] }
}

export let hooks = {
  HookTableRowFnConfirm,
  HookFormAdd,
  HookField_U_CardCode_GetList,
  HookLookupsRefresh,
  HookField_U_Id_GetValueRender,
}

const getRandomId = () => {
  const list = "ABCDEFGHIJKLMNPQRSTUVWXYZ123456789"
  var res = ""
  for (var i = 0; i < 10; i++) {
    var rnd = Math.floor(Math.random() * list.length)
    res = res + list.charAt(rnd)
  }
  return res
}
